module.exports = __webpack_public_path__ + "img/wide.b3794724.jpg";